<nav>
  <!-- home page  -->
  <df-base-nav-link
    [name]="'Navigation.Home' | translate"
    [routerLinkUrl]="n.getPath('home')"
    [matchActiveClass]="[n.getPath('home')]"
    iconSrc="/assets/img/ic_apps.svg"
  ></df-base-nav-link>

  <!-- section Funnels title -->
  <p class="tui-text_menu-header text-[#ABB9FF] mt-4">
    {{ 'Navigation.Funnels header' | translate }}
  </p>
  <!-- Funnel name -->
  <!-- <df-base-nav-funnel></df-base-nav-funnel> -->

  <df-base-nav-link
    data-test="current-funnel-nav-link"
    *ngIf="(userService.currentUser$ | async)?.contextFunnel as contextFunnel"
    class="context-funnel"
    [name]="contextFunnel.name || ''"
    [routerLinkUrl]="n.getPath('funnels/f/d/:id', {}, { id: contextFunnel.id })"
    [matchActiveClass]="[n.getPath('funnels/f/d/:id').split(':')[0], 'manage']"
    iconSrc="/assets/img/ic_home.svg"
  ></df-base-nav-link>

  <!-- All funnels -->
  <df-base-nav-link
    data-test="all-funnels-nav-link"
    [name]="'Navigation.All funnels' | translate"
    [routerLinkUrl]="n.getPath('funnels/list/all')"
    [matchActiveClass]="[n.getPath('funnels/list/all')]"
    iconSrc="/assets/img/ic_funnel.svg"
  ></df-base-nav-link>

  <ng-container *ngIf="!userService.User?.isSemrushPlan()">
    <!-- Section work flows title -->
    <div class="flex justify-between items-center mt-4">
      <p class="tui-text_menu-header text-[#ABB9FF]">
        {{ 'Navigation.Flows' | translate }}
      </p>
      <p class="tui-text_menu-header text-[#804DD9] bg-[#E5D6FF] p-1 rounded">
        {{ 'Navigation.Beta' | translate }}
      </p>
    </div>

    <!--Flows -->
    <df-base-nav-link
      [name]="'Navigation.FlowsLibrary' | translate"
      data-test="flows-nav-link"
      [routerLinkUrl]="n.getPath('work-flows/list/all')"
      [matchActiveClass]="[n.getPath('work-flows/list/all')]"
      iconSrc="/assets/img/ic_bolt.svg"
    >
    </df-base-nav-link>

    <!-- My flows -->
    <df-base-nav-link
      [name]="'Navigation.SavedFlows' | translate"
      data-test="my-flows-nav-link"
      [routerLinkUrl]="n.getPath('work-flows/list/my')"
      [matchActiveClass]="[n.getPath('work-flows/list/my')]"
      iconSrc="/assets/img/ic_landscape_document.svg"
    ></df-base-nav-link>

    <!-- Custom flows -->
    <df-base-nav-link
      [name]="'Navigation.CreatedFlows' | translate"
      data-test="my-flows-nav-link"
      [routerLinkUrl]="n.getPath('work-flows/list/custom')"
      [matchActiveClass]="[n.getPath('work-flows/list/custom')]"
      iconSrc="/assets/img/ic_pencil.svg"
    ></df-base-nav-link>
  </ng-container>

  <!-- section Tactics title -->
  <p class="tui-text_menu-header text-[#ABB9FF] mt-4">
    {{ 'Navigation.Tactics header' | translate }}
  </p>

  <!-- Tactic library -->
  <df-base-nav-link
    *ngIf="!disableTacticsLinks"
    data-test="tactic-library-nav-link"
    [name]="'Navigation.Tactics' | translate"
    [routerLinkUrl]="n.getPath('/tactics/list/all')"
    [matchActiveClass]="[n.getPath('/tactics/list/all')]"
    iconSrc="/assets/img/ic_folder_open.svg"
  ></df-base-nav-link>

  <!-- My tactics -->
  <df-base-nav-link
    *ngIf="!disableTacticsLinks"
    data-test="my-tactic-nav-link"
    [name]="'Navigation.My tactics' | translate"
    [routerLinkUrl]="n.getPath('tactics/list/my-tactics')"
    [matchActiveClass]="[n.getPath('tactics/list/my-tactics')]"
    iconSrc="/assets/img/ic-my-tactics.svg"
  ></df-base-nav-link>

  <!-- Growth Hackers -->
  <df-base-nav-link
    data-test="growth-hackers-nav-link"
    *ngIf="!userService.User?.isSemrushPlan()"
    [name]="'Navigation.Growth Hackers' | translate"
    [routerLinkUrl]="n.getPath('users/list')"
    [matchActiveClass]="[n.getPath('users/list')]"
    iconSrc="/assets/img/ic_users_alt.svg"
  ></df-base-nav-link>

  <!-- section Tools title -->
  <p class="tui-text_menu-header text-[#ABB9FF] mt-4">
    {{ 'Navigation.Tools' | translate | uppercase }}
  </p>

  <!-- Graphics creator -->
  <df-base-nav-link
    data-test="graphics-creator-nav-link"
    *ngIf="(userService.currentUser$ | async)?.contextFunnel as contextFunnel"
    [name]="'Navigation.Graphics creator' | translate"
    [routerLinkUrl]="n.getPath('funnels/f/d/:id/graphics', {}, { id: contextFunnel.id })"
    [matchActiveClass]="[
      n.getPath('funnels/f/d/:id/graphics').split(':')[0],
      this.n.getPath('funnels/f/d/:id/graphics').split('/').slice(-1)!.pop() || '/'
    ]"
    iconSrc="/assets/img/ic-generator-graphics.svg"
  ></df-base-nav-link>

  <!-- Content generator -->
  <df-base-nav-link
    data-test="content-generator-nav-link"
    *ngIf="(userService.currentUser$ | async)?.contextFunnel as contextFunnel"
    [name]="'Navigation.Content generator' | translate"
    [routerLinkUrl]="n.getPath('funnels/f/d/:id/content-generator-library', {}, { id: contextFunnel.id })"
    [matchActiveClass]="['content-generator']"
    iconSrc="/assets/img/ic-generator-content.svg"
  ></df-base-nav-link>

  <!-- Marketing Assistant (ChatGPT) -->
  <df-base-nav-link
    data-test="chat-gpt-nav-link"
    style="margin-left: 2px"
    *ngIf="(userService.currentUser$ | async)?.contextFunnel as contextFunnel"
    [name]="'Navigation.Marketing Assistant' | translate"
    [routerLinkUrl]="n.getPath('funnels/f/d/:id/marketing-assistant', {}, { id: contextFunnel.id })"
    [matchActiveClass]="[
      n.getPath('funnels/f/d/:id/marketing-assistant').split(':')[0],
      this.n.getPath('funnels/f/d/:id/marketing-assistant').split('/').slice(-1)!.pop() || '/'
    ]"
    iconSrc="/assets/img/ic-marketing-assistant.svg"
  ></df-base-nav-link>

  <!-- Asset Library -->
  <df-base-nav-link
    data-test="asset-library-nav-link"
    style="margin-left: 2px"
    *ngIf="(userService.currentUser$ | async)?.contextFunnel as contextFunnel"
    [name]="'Navigation.Asset Library' | translate"
    [routerLinkUrl]="n.getPath('funnels/f/d/:id/assets-library', {}, { id: contextFunnel.id })"
    [matchActiveClass]="[
      n.getPath('funnels/f/d/:id/assets-library').split(':')[0],
      this.n.getPath('funnels/f/d/:id/assets-library').split('/').slice(-1)!.pop() || '/'
    ]"
    iconSrc="/assets/img/ic-marketing-assistant.svg"
  ></df-base-nav-link>

  <!-- Ad Library -->
  <ng-container *ngIf="!userService.User?.isSemrushPlan()">
    <df-base-nav-link
      style="margin-left: 2px"
      [name]="'Navigation.Ad Library' | translate"
      routerLinkUrl="ad-library"
      [matchActiveClass]="[n.getPath('ad-library')]"
      iconSrc="/assets/img/ic_megaphone.svg"
    ></df-base-nav-link>
  </ng-container>

  <div *ngIf="(userService.currentUser$ | async)?.isAdmin">
    <p class="tui-text_menu-header text-[#ABB9FF] mt-4">
      {{ 'Navigation.Admin' | translate | uppercase }}
    </p>
    <df-base-nav-link
      data-test="prompts-nav-link"
      [name]="'Navigation.Prompts' | translate"
      [routerLinkUrl]="n.getPath('prompt/list')"
      [matchActiveClass]="[n.getPath('prompt/list')]"
      iconSrc="/assets/img/ic_file_export.svg"
    ></df-base-nav-link>

    <df-base-nav-link
      data-test="canvas-nav-link"
      [name]="'Navigation.Canvas' | translate"
      [routerLinkUrl]="n.getPath('canvas/list')"
      [matchActiveClass]="[n.getPath('canvas/list')]"
      iconSrc="/assets/img/ic_file_export.svg"
    ></df-base-nav-link>

    <df-base-nav-link
      [name]="'Login As User'"
      [routerLinkUrl]="n.getPath('login-as-user')"
      [matchActiveClass]="[n.getPath('login-as-user')]"
      iconSrc="/assets/img/ic_file_export.svg"
    ></df-base-nav-link>
  </div>
</nav>
<ng-container #container></ng-container>
